import { ENDPOINTS, getFullUrl } from "./config";

export class ClinicDriverService {
  static getToken(): string | null {
    return localStorage.getItem("token");
  }
  static getRole(): string | null {
    return localStorage.getItem("auth_user");
  }

  static async getDriverListing(
    page = 1,
    pageSize = 10,
    clinicId: string,
    filters: {
      type?: "driver" | "pickup";
    }
  ): Promise<{
    success: boolean;
    message?: string;
    data?: {
      pagination: {
        totalItems: number;
        totalPages: number;
        page: number;
      };
    };
  }> {
    try {
      const filtersObj: Record<string, any> = {};
      if (filters.type) {
        filtersObj.type = filters.type;
      }

      const params = new URLSearchParams({
        page: page.toString(),
        pageSize: pageSize.toString(),
        filters: JSON.stringify(filtersObj),
      });

      if (clinicId) {
        params.append("clinicId", clinicId);
      }

      const url = `${getFullUrl(
        ENDPOINTS.DRIVER.GETDRIVERLISTING
      )}?${params.toString()}`;

      const response = await fetch(url.toString(), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }

  static async getDriverDetails(driverId: string): Promise<any> {
    try {
      const url = getFullUrl(
        `${ENDPOINTS.DRIVER.GETDRIVERDETAILS}?driverId=${driverId}`
      );
      console.log("url", url);
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.getToken()}`,
        },
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to fetch orders:", error);
      throw error;
    }
  }

  static async createDriver(
    data: any,
    files: Record<string, File>
  ): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.DRIVER.CREATEDRIVER}`);

      // Create FormData for file uploads
      const formData = new FormData();

      // Append all regular data fields
      for (const key in data) {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }

      // Append all files
      for (const [key, file] of Object.entries(files)) {
        if (file) {
          formData.append(key, file);
        }
      }

      const response = await fetch(url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          // Don't set Content-Type - let the browser set it with boundary
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to create driver:", error);
      throw error;
    }
  }

  static async updateDriver(
    driverId:string,
    data: any,
    files: Record<string, File>
  ): Promise<any> {
    try {
      const url = getFullUrl(`${ENDPOINTS.DRIVER.UPDATEDRIVER}`);
      const URL=`${url}/${driverId}`;
      // Create FormData for file uploads
      const formData = new FormData();

      // Append all regular data fields
      for (const key in data) {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      }

      // Append all files
      for (const [key, file] of Object.entries(files)) {
        if (file) {
          formData.append(key, file);
        }
      }

      const response = await fetch(URL, {
        method: "PATCH",
        headers: {
          Authorization: `Bearer ${this.getToken()}`,
          // Don't set Content-Type - let the browser set it with boundary
        },
        body: formData,
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Failed to update driver:", error);
      throw error;
    }
  }


}
